var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M392.25 134.405L504.32 238.407C514.559 247.905 514.559 264.095 504.32 273.595L392.25 377.595C385.258 384.079 375.066 385.813 366.312 381.999C357.555 378.188 351.895 369.548 351.895 360.001V295.999H40C17.906 295.999 0 278.093 0 255.999S17.906 215.999 40 215.999H351.895V151.999C351.895 142.452 357.555 133.811 366.312 129.997C375.066 126.186 385.258 127.921 392.25 134.405Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLong);
export default __webpack_public_path__ + "static/media/right-long.77fabbe1794c26f7f043f61712bc03fe.svg";
export { ForwardRef as ReactComponent };